export function searchHandler() {

    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    var searchInput = document.querySelector('#site-search input[name="s"]');
    var resultsContainer = document.getElementById('search-results-container');

    searchInput.addEventListener('input', function () {
        var searchTerm = this.value;

        delay(function () {
            if (searchTerm.length > 2) {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', ajaxurl + '?action=get_search_results&term=' + searchTerm, true);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4 && xhr.status === 200) {
                        var response = JSON.parse(xhr.responseText);
                        // Display the suggested results
                        displayResults(response);
                    }
                };
                xhr.send();
            } else {
                // Clear the results container when the search term is too short
                resultsContainer.innerHTML = '';
            }
        }, 500); // Set the delay time (in milliseconds)
    });

    function displayResults(results) {
        // Clear previous results
        resultsContainer.innerHTML = '';

        // Create a list and append results
        var resultList = document.createElement('ul');
        resultList.classList.add('search-results');
        results.forEach(function (result) {
            var listItem = document.createElement('li');
            listItem.classList.add('search-results-item');
            listItem.innerHTML = '<a href="' + result.permalink + '">' + result.title + '</a>';
            resultList.appendChild(listItem);
        });

        // Append the list to the container
        resultsContainer.appendChild(resultList);

        resultsContainer.classList.add('site-header__search-results--active');
    }
}

